/**
 * Numbered list — used for "Six reasons clients partner with us" / values-on-home
 * Two-column grid with a gold numbered circle badge + title + description.
 */
export default function NumberedList({ section }) {
  const { eyebrow, heading, paragraphs = [], cards = [], theme = "white" } = section;
  const bgClass = theme === "navy" ? "bg-mist-navy text-white" : theme === "off" ? "bg-mist-off" : "bg-white";
  const headingColor = theme === "navy" ? "text-white" : "text-mist-navy";
  const paraColor = theme === "navy" ? "text-white/70" : "text-mist-ink/75";
  const itemTitle = theme === "navy" ? "text-white" : "text-mist-navy";
  const itemDesc = theme === "navy" ? "text-white/70" : "text-mist-ink/70";

  return (
    <section className={`${bgClass} py-24 lg:py-32`}>
      <div className="container-mist">
        <div className="max-w-2xl text-left">
          {heading && (
            <h2 className={`font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-tight ${headingColor}`}>
              {heading}
            </h2>
          )}
          {(eyebrow || heading) && <div className="mt-4 gold-divider" />}
          {paragraphs[0] && <p className={`mt-5 text-[15px] leading-relaxed ${paraColor}`}>{paragraphs[0]}</p>}
        </div>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8">
          {cards.map((c, i) => (
            <div key={i} data-testid={c.testid || `strength-${i}`} className="flex gap-5">
              <div className="h-9 w-9 rounded-full bg-mist-gold/15 border border-mist-gold/30 grid place-items-center shrink-0 text-mist-gold font-display text-sm">
                {c.number || String(i + 1).padStart(2, "0")}
              </div>
              <div>
                {c.title && <h3 className={`font-medium text-base ${itemTitle}`}>{c.title}</h3>}
                {c.description && (
                  <p className={`text-sm mt-1.5 leading-relaxed ${itemDesc}`}>{c.description}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
